export default __webpack_public_path__ + "static/media/Ripple.5eb08b04.svg";